import axios from 'axios';
import { API_BASE_URL } from './appConfig';

const adminInstance = axios.create({
    baseURL: API_BASE_URL
});

adminInstance.interceptors.request.use(
    (config) => {
        const authTokenDetail = sessionStorage.getItem('loginToken');
       // console.log(authTokenDetail);
    if (authTokenDetail) {
      config.headers['Authorization'] = `Bearer ${authTokenDetail}`;
    }
    config.headers['Access-Control-Allow-Origin'] = '*';

    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    //config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// adminInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

adminInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.clear(); // optional: clear token/session
      window.location.href = '/login'; // redirect to login page
    }
    return Promise.reject(error);
  }
);


export { adminInstance };
